import { useEffect } from 'react';
import { fetchJson } from '@frontend/store/fetch';

interface ISaveAccountActivationProps {
    activationToken: string;
    goToNextStep: () => void;
}

// This component is purely for the side effect of activating the account.
// No view is necessary
export function SaveAccountActivation({ activationToken, goToNextStep }: Readonly<ISaveAccountActivationProps>) {
    useEffect(() => {
        const postActivateAccount = async () => {
            await activateAccount(activationToken);

            goToNextStep();
        };

        postActivateAccount();
    }, []);

    return null;
}

async function activateAccount(activationToken: string) {
    await fetchJson('/api/activatePractitioner', 'POST', {
        activationToken,
    });
}
